export function flattenIds(notifications) {
    var _a;
    if (!Array.isArray(notifications)) {
        notifications = [notifications];
    }
    return (_a = []).concat.apply(_a, notifications.map(function (n) { return n.aggregated ? n.subNotifications : n.eventId; }));
}
